'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayName = exports.options = exports.theme = exports.Question = undefined;

var _normal = require('./_normal.scss');

var _normal2 = _interopRequireDefault(_normal);

var _identifiers = require('../identifiers');

var _TextRedraft = require('./../../atoms/TextRedraft');

var _TextRedraft2 = _interopRequireDefault(_TextRedraft);

var _factory = require('./factory');

var _factory2 = _interopRequireDefault(_factory);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var Question = (0, _factory2['default'])({
  identifier: _identifiers.QUESTION,
  TextEditor: _TextRedraft2['default']
});
exports.Question = Question;
exports.theme = _normal2['default'];
exports.options = _factory.options;
exports.displayName = _identifiers.QUESTION;
/** @component */

exports['default'] = Question;